import { Box, Divider } from '@televet/kibble-ui';
import React from 'react';
import AutomationsSection from './components/AutomationsSection';
import WidgetRequestsSection from './components/WidgetRequestsSection';

const TaskSettings = (): JSX.Element => {
  return (
    <Box py={5}>
      <AutomationsSection />
      <Divider my={6} />
      <WidgetRequestsSection />
    </Box>
  );
};

export default TaskSettings;
